import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { portalApi } from '@/api/portal.api';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';
export function PortalLoginPage() {
  const [searchParams] = useSearchParams();
  const [organizationId, setOrganizationId] = useState(searchParams.get('org') ?? '');
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  useEffect(() => {
    const org = searchParams.get('org');
    if (org) setOrganizationId(org);
  }, [searchParams]);

  const requestLink = async () => {
    const orgId = Number(organizationId);
    if (!orgId || !email.trim()) {
      notify.error('Enter organization ID and email');
      return;
    }
    try {
      await portalApi.requestLink(orgId, email.trim());
      setSent(true);
      notify.success('If registered, a sign-in link was sent');
    } catch (err) {
      showApiError(err, 'Request failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-6">
      <div className="card max-w-md w-full p-8 space-y-4 shadow-lg">
        <h1 className="text-xl font-semibold text-slate-900">Customer portal</h1>
        <p className="text-sm text-slate-600">Sign in to view invoices, tickets, and support history.</p>
        {sent ? (
          <p className="text-sm text-emerald-700">Check your email for the magic link.</p>
        ) : (
          <>
            <Input
              label="Organization ID"
              value={organizationId}
              onChange={(e) => setOrganizationId(e.target.value)}
            />
            <p className="text-xs text-slate-500">Your org admin can share the portal link from Desk setup.</p>
            <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <Button onClick={requestLink}>Send magic link</Button>
          </>
        )}
        <p className="text-xs text-slate-500">
          Have a link? <Link to="/portal/verify" className="text-primary-600">Verify here</Link>
        </p>
      </div>
    </div>
  );
}
